import classNames from 'classnames';
import { Link } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { CabinetTemplate } from '@/widgets/Templates';

import { ConditionView, ContentField, Typography } from '@/shared/ui';

import { queryKeys } from '@/api/queryKeys';
import { ROUTES_BY_SERVICE_CODE } from '@/router/config';

import { SERVICE_CODES } from '@/lib/consts';

import api from '@/api';

import { InsuranceOrdersList, InsuranceOrdersListSkeleton } from './ui';

import './InsuranceOrders.scss';

export const InsuranceOrders: React.FC = () => {
  const { isLoading: areInsuranceOrdersLoading, data: insuranceOrders = [] } = useQuery({
    queryKey: queryKeys.insuranceOrders.list(),
    queryFn: () => api.bia.insuranceOrders(true).then((r) => r.data),
  });

  return (
    <CabinetTemplate title="Страхування">
      <div
        className={classNames('insurance-orders__container', {
          'insurance-orders__container--loading': areInsuranceOrdersLoading,
        })}
      >
        <ConditionView if={!areInsuranceOrdersLoading} else={<InsuranceOrdersListSkeleton />}>
          <ConditionView
            if={!!insuranceOrders?.length}
            else={
              <ContentField
                icon="hi"
                content={
                  <Typography color="graphite" textCenter>
                    Наразі у вас немає жодного поліса страхування. <br />
                    Коли ви замовите поліс, він зʼявиться тут. <br />
                    Також ви можете{' '}
                    <Link to={ROUTES_BY_SERVICE_CODE[SERVICE_CODES.INSURANCE]}>замовити поліс прямо зараз</Link>
                  </Typography>
                }
              />
            }
          >
            <InsuranceOrdersList insuranceOrders={insuranceOrders ?? []} />
          </ConditionView>
        </ConditionView>
      </div>
    </CabinetTemplate>
  );
};
